import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import MembersContainer from './MembersContainer'


const MembersRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><MembersContainer></MembersContainer></Provider>
}

MembersRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default MembersRoot
